import Axios from "axios";
import { SET_HRM_LETTER_INFO_LIST, UNSET_HRM_LETTER_INFO_LIST } from "@/store/mutation-types";

import { 
    saveUpdateHrmLetter,
    saveUpdateHrmLetterInfo, 
    getHrmLetterInfo, 
    getHrmLetterInfoById
} from "@/store/api";

// initial state
const state = {
    getHrmLetterInfo: [],
}

const getters = {
    getHrmLetterInfo(state){
        return state.getHrmLetterInfo;
    }

}

const mutations = {
    [SET_HRM_LETTER_INFO_LIST](state, data) {
        state.getHrmLetterInfo = data;
    },
    [UNSET_HRM_LETTER_INFO_LIST](state) {
        state.getHrmLetterInfo = [];
    }
}

const actions = {
    saveUpdateHrmLetterInfo({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateHrmLetterInfo, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    saveUpdateHrmLetter({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateHrmLetter, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getHrmLetterInfo({ commit }) {
        return new Promise((resolve, reject) => {
            Axios.get(getHrmLetterInfo)
                .then(function (response) { 
                    commit(SET_HRM_LETTER_INFO_LIST, response.data.data);
                    resolve(response.data.data);  
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getHrmLetterInfoById({ commit }, id) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(`${getHrmLetterInfoById}/${id}`)
                .then(function (response) {
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
}


export default {
    state,
    getters,
    actions,
    mutations,
};